export function tableSections(table, keyFn) {
  const cells = []
  const tables = Array.isArray(table) ? table : [table]

  for (const t of tables) {
    for (let rowI = 0; rowI < t.rows.length; rowI++) {
      const row = t.rows[rowI]
      const key = keyFn ? keyFn(row, rowI) : row.dataset.row || rowI
      let dayI = 0
      let cellI = 0

      Array.from(row.cells).forEach((cell) => {
        if (cell.tagName == "TH") return

        if (!cells[dayI]) cells[dayI] = {}
        if (!cells[dayI][key]) cells[dayI][key] = []
        cells[dayI][key].push(cell)

        cellI += cell.colSpan
        const { days } = cells[dayI]
        if (days && days.length && cellI >= days[0].colSpan) {
          cellI = 0
          dayI++
        }
      })
    }
  }

  return cells
}
